import {
  BudgetEditor,
  DateISOEditor,
  FlatSelectEditor,
  GoalEditor,
  NumberEditor,
  PercentEditor,
  RelatedSelectEditor,
  TextEditor,
} from '@mint-lib/ag-grid/editors';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import BudgetRendered from '../shared/ColumnFields/ReadOnly/BudgetRenderer.jsx';
import DateRenderer from '../shared/ColumnFields/ReadOnly/DateRenderer.jsx';
import { GoalRenderer } from '../shared/ColumnFields/ReadOnly/GoalRenderer.jsx';
import { NumberRenderer } from '../shared/ColumnFields/ReadOnly/NumberRenderer.jsx';
import { PercentRenderer } from '../shared/ColumnFields/ReadOnly/PercentRenderer.jsx';
import { SelectRenderer } from '../shared/ColumnFields/ReadOnly/SelectRenderer.jsx';
import TextRendered from '../shared/ColumnFields/ReadOnly/TextRenderer.jsx';

type ColumnType = MediaPlan.Column['type'];

export const CELL_RENDERER_BY_TYPE: Record<ColumnType, unknown> = {
  currency: BudgetRendered,
  free_form_text: TextRendered,
  date: DateRenderer,
  integer: NumberRenderer,
  percent: PercentRenderer,
  select: SelectRenderer,
  decimal: NumberRenderer,
  reference: GoalRenderer,
};

type CellType = ColumnType | 'related_select';

export const CELL_EDITOR_BY_TYPE: Record<CellType, unknown> = {
  currency: BudgetEditor,
  free_form_text: TextEditor,
  date: DateISOEditor,
  integer: NumberEditor,
  percent: PercentEditor,
  select: FlatSelectEditor,
  decimal: NumberEditor,
  related_select: RelatedSelectEditor,
  reference: GoalEditor,
};

export const POPUP_EDITORS_TYPES: ColumnType[] = [
  'date',
  'select',
  'reference',
];

export const EMPTY_CELL_VALUE = null;

export const TOTALS_ROW_ID = 'totals';
